import React, { useState, useEffect } from "react";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../../firebase";
import Display from "./display";


function Jobs() {
    const [indust, setindust] = useState([]);
    const ref = collection(db, `Industry`);
    useEffect(() => {
        const getjob = async () => {
          const data = await getDocs(ref);
          setindust(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        };
        console.log("heheheh")
        getjob();
      },[]);
    
  return (
    <div>
        {indust.map((post,i) => {
        return (
          <div className="post" key={i}>
           <Display uid={post.uid} name={post.cname}/> 
          </div>
        );
      })}
    </div>
  )
}

export default Jobs;
